import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate, useRouteLoaderData } from "react-router-dom";

import { useAppApi } from "@/App";
import { DevForm, FormFieldGroup } from "@components/Forms/Fields";
import { fieldChange, useSubmit } from "@components/Forms/Handlers";
import { DefaultLayout } from "@components/Layouts";
import { CommonCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function TouAcceptScreen() {
    const { t } = useTranslation();
    const { apiData, setApiData } = useAppApi(url_reverse("api:tou_accept"));
    const onFormSubmit = useSubmit();
    const navigate = useNavigate();
    const commonInfo = useRouteLoaderData("commonInfo");

    useEffect(() => {
        if (commonInfo.errcode !== "need_tou_accept") {
            navigate(url_reverse("games:list"));
        }
    }, [commonInfo.errcode]);

    if (!apiData) return;

    const lbl = (
        <a href="https://documentation.vkplay.ru/terms_vkp/developer_dashboard_tou" target="_blank">
            {t("Пользовательское соглашение об использовании кабинета разработчика")}
        </a>
    );

    return (
        <DefaultLayout width={75}>
            <CommonCard header={t("Для продолжения использования кабинета разработчика примите соглашение ниже")}>
                <Form onSubmit={onFormSubmit}>
                    <FormFieldGroup colLabel={0} colField={12}>
                        <DevForm.Checkbox
                            label={lbl}
                            checked={apiData.forms_data?.main.data.tou_accept}
                            onChange={(ev) => {
                                fieldChange({
                                    prefix: "main",
                                    apiData,
                                    setApiData,
                                    name: "tou_accept",
                                    val: ev.target.checked,
                                });
                            }}
                        />
                    </FormFieldGroup>
                    <DevForm.Button
                        type="submit"
                        variant="primary"
                        name="continue"
                        disabled={!apiData.forms_data?.main.data.tou_accept}
                    >
                        {t("Далее")}
                    </DevForm.Button>
                </Form>
            </CommonCard>
        </DefaultLayout>
    );
}
